import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './Card';
import { TargetIcon, FileTextIcon, CheckIcon } from '../../assets/icons';

export const ScreeningMockPanel: React.FC = () => {
  return (
    <div className="relative w-full h-[520px]" style={{ perspective: '1200px' }}>
      {/* Card 1 - Score (Main, front) */}
      <motion.div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-64 z-30"
        initial={{ opacity: 0, y: 30, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.2, ease: [0.25, 0.1, 0.25, 1] }}
      >
        <Card className="p-6 shadow-2xl">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-accent-1 to-accent-2 flex items-center justify-center shadow-lg">
              <TargetIcon className="w-6 h-6 text-white" />
            </div>
            <div>
              <div className="text-xs text-white/50 font-medium uppercase tracking-wide">Score global</div>
              <div className="text-4xl font-bold text-gradient">86</div>
            </div>
          </div>

          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-sm text-white/60">Technique</span>
              <span className="text-sm text-white font-semibold">92</span>
            </div>
            <div className="h-2 bg-white/10 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-accent-1 to-accent-2 rounded-full" style={{ width: '92%' }} />
            </div>

            <div className="flex justify-between items-center">
              <span className="text-sm text-white/60">Soft skills</span>
              <span className="text-sm text-white font-semibold">78</span>
            </div>
            <div className="h-2 bg-white/10 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-accent-2 to-accent-3 rounded-full" style={{ width: '78%' }} />
            </div>

            <div className="flex justify-between items-center">
              <span className="text-sm text-white/60">Fit culturel</span>
              <span className="text-sm text-white font-semibold">88</span>
            </div>
            <div className="h-2 bg-white/10 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-accent-3 to-accent-1 rounded-full" style={{ width: '88%' }} />
            </div>
          </div>
        </Card>
      </motion.div>

      {/* Card 2 - Resume (Middle, right) */}
      <motion.div
        className="absolute top-32 right-0 w-72 z-20"
        initial={{ opacity: 0, y: 40, scale: 0.92 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.35, ease: [0.25, 0.1, 0.25, 1] }}
        style={{
          transform: 'translateZ(-20px) rotateY(-2deg)',
          transformStyle: 'preserve-3d',
        }}
      >
        <Card className="p-6 shadow-xl">
          <div className="flex items-center gap-3 mb-4">
            <FileTextIcon className="w-5 h-5 text-accent-1" />
            <div className="text-base font-semibold text-white">Résumé IA</div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed mb-4">
            Profil senior avec 8 ans d'expérience en développement full-stack. Expertise solide en architecture système.
          </p>
          <div className="flex flex-wrap gap-2">
            <span className="px-3 py-1.5 rounded-lg bg-accent-1/15 border border-accent-1/30 text-accent-1 text-xs font-medium">
              React
            </span>
            <span className="px-3 py-1.5 rounded-lg bg-accent-2/15 border border-accent-2/30 text-accent-2 text-xs font-medium">
              Node.js
            </span>
            <span className="px-3 py-1.5 rounded-lg bg-accent-3/15 border border-accent-3/30 text-accent-3 text-xs font-medium">
              TypeScript
            </span>
          </div>
        </Card>
      </motion.div>

      {/* Card 3 - Validation (Back, left) */}
      <motion.div
        className="absolute bottom-0 left-0 w-64 z-10"
        initial={{ opacity: 0, y: 50, scale: 0.9 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
        style={{
          transform: 'translateZ(-40px) rotateY(2deg)',
          transformStyle: 'preserve-3d',
        }}
      >
        <Card className="p-6 shadow-lg">
          <div className="text-base font-semibold text-white mb-4">Validations clés</div>
          <div className="space-y-3">
            {[
              'Expérience microservices',
              'Gestion équipe distribuée',
              'Approche testing & qualité',
            ].map((item, idx) => (
              <div key={idx} className="flex items-start gap-3">
                <CheckIcon className="w-5 h-5 text-accent-1 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-white/70">{item}</span>
              </div>
            ))}
          </div>
        </Card>
      </motion.div>
    </div>
  );
};
